<template>
  <v-list-group :value="false" active-class="primary white--text">
    <template v-slot:activator>
      <v-list-item-icon class="mr-4">
        <v-icon>mdi-file-document</v-icon>
      </v-list-item-icon>
      <v-list-item-title>Sổ sách</v-list-item-title>
    </template>

    <v-list class="py-0">
      <!-- <v-list-item active-class="blue lighten-4 primary--text" class="px-0" link to="/managerDocumentTypes">
        <v-list-item-action></v-list-item-action>
        <v-list-item-title>Sổ sách nhà trường</v-list-item-title>
      </v-list-item> -->

      <v-list-item active-class="blue lighten-4 primary--text" class="px-0" link to="/teacherDoc">
        <v-list-item-action></v-list-item-action>
        <v-list-item-title>Sổ sách giảng dạy</v-list-item-title>
      </v-list-item>
      <v-list-item active-class="blue lighten-4 primary--text" class="px-0" link to="/classDoc" v-if="ownClassIds">
        <v-list-item-action></v-list-item-action>
        <v-list-item-title>Sổ sách chủ nhiệm</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-list-group>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  computed: {
    ...mapGetters('auth', ['ownClassIds'])
  }
}
</script>
